<main class="reports-page">
  <section class="reports__container">
    <header class="reports__header">
      <div>
        <h1>{{ 'reports.consumer.title' | translate }}</h1>
        <p>{{ 'reports.consumer.subtitle' | translate }}</p>
      </div>
    </header>

    <div class="entity-warning surface-card" *ngIf="hasGlobalDataScope">
      {{ 'common.entitySelectionWarning' | translate }}
    </div>

    <section class="reports__insights" *ngIf="!hasGlobalDataScope">
      <div class="reports__filters surface-card">
        <div class="reports__filter-field">
          <label>{{ 'reports.filters.year' | translate }}</label>
          <app-custom-select
            [(ngModel)]="selectedYear"
            (ngModelChange)="onYearChange()"
            [options]="yearOptions"
            [placeholder]="'reports.filters.year' | translate">
          </app-custom-select>
        </div>
        <div class="reports__filter-field">
          <label>{{ 'reports.filters.month' | translate }}</label>
          <app-custom-select
            [(ngModel)]="selectedMonth"
            (ngModelChange)="loadReports()"
            [options]="monthOptions"
            [placeholder]="'reports.filters.month' | translate"
            [disabled]="selectedYear === 'all'">
          </app-custom-select>
        </div>
      </div>

      <div class="reports__tables">
        <p class="list-status" *ngIf="isLoading">{{ 'common.loading' | translate }}</p>
        <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

        <section class="reports__entity-section" *ngIf="!isLoading && !loadingError">
          <div class="reports__entity-list surface-card">
            <div class="reports__entity-list-header">
              <span>{{ 'reports.entity.table.description' | translate }}</span>
              <span class="reports__entity-list-header-quantity">{{ 'reports.entity.table.quantity' | translate }}</span>
              <span class="reports__entity-list-header-amount">{{ 'reports.entity.table.amount' | translate }}</span>
              <span aria-hidden="true"></span>
            </div>
            <div class="reports__entity-list-body">
              <p class="list-status" *ngIf="!reportRows.length && !isCreatingCustomRow">
                {{ 'reports.entity.emptyPeriod' | translate }}
              </p>
              <ng-container *ngFor="let row of consumerSummaryRows">
                <div class="reports__entity-row"
                     [class.reports__entity-row--group]="row.kind === 'group'"
                     [class.reports__entity-row--custom]="row.kind === 'custom'"
                     [class.reports__entity-row--total]="row.kind === 'total'"
                     [class.reports__entity-row--expanded]="row.groupKey && expandedGroups.has(row.groupKey)">
                  <div class="reports__cell-labels">
                    <div class="reports__cell-title">
                      {{ row.label }}
                      <button
                        *ngIf="row.kind === 'custom' && hasGlobalDataAccess && !isCreatingCustomRow"
                        type="button"
                        class="reports__row-edit-btn"
                        [title]="'common.edit' | translate"
                        (click)="startEditCustomRow(row.source!)">
                        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                          <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z"/>
                          <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z"/>
                        </svg>
                      </button>
                      <button
                        *ngIf="row.kind === 'custom' && hasGlobalDataAccess && !isCreatingCustomRow"
                        type="button"
                        class="reports__row-delete-btn"
                        [title]="'reports.actions.delete' | translate"
                        (click)="confirmDeleteCustomRow(row.source!)">
                        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                          <path d="M4 6h12"/>
                          <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h1A1.5 1.5 0 0 1 12 4.5V6"/>
                          <path d="M5.5 6l.6 9.4A1.5 1.5 0 0 0 7.6 17h4.8a1.5 1.5 0 0 0 1.5-1.6L14.5 6"/>
                        </svg>
                      </button>
                    </div>
                    <div class="reports__cell-subtitle" *ngIf="row.subLabel">{{ row.subLabel }}</div>
                  </div>
                  <div class="reports__cell-counts">
                    <div class="reports__cell-count" *ngIf="row.count != null">{{ row.count | number:'1.0-0':locale }}</div>
                    <div class="reports__cell-subcount" *ngIf="row.subCount != null">{{ row.subCount | number:'1.0-0':locale }}</div>
                  </div>
                  <div class="reports__entity-amount is-spent">
                    {{ row.amount | currency:'EUR':'symbol':'1.2-2':locale }}
                  </div>
                  <div class="reports__expand-cell">
                    <button *ngIf="row.entryList?.length"
                            type="button"
                            class="reports__expand-btn"
                            [class.is-open]="row.groupKey && expandedGroups.has(row.groupKey!)"
                            (click)="toggleGroupExpand(row.groupKey!)">
                      <svg viewBox="0 0 20 20" aria-hidden="true">
                        <path d="M5 8l5 5 5-5" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="reports__expand-panel"
                     *ngIf="row.groupKey && expandedGroups.has(row.groupKey) && row.entryList?.length">
                  <p class="reports__expand-loading" *ngIf="loadingNameGroups.has(row.groupKey!)">
                    {{ 'common.loading' | translate }}
                  </p>
                  <div class="reports__expand-item" *ngFor="let entryId of getSortedEntryList(row.entryList)">
                    <span class="reports__expand-item-label reports__expand-item-link"
                          (click)="openAudience(entryId)"
                          [title]="entryId">
                      {{ getAudienceName(entryId) }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
            <button
              *ngIf="showCustomRowTrigger && !isCreatingCustomRow"
              type="button"
              class="reports__table-add-button"
              (click)="startCustomRow()">+</button>
          </div>

          <!-- Delete custom row confirmation -->
          <ng-container *ngIf="deleteTarget">
            <div class="reports__modal-backdrop" (click)="cancelDeleteCustomRow()">
              <div class="reports__confirm-modal surface-card" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
                <div class="reports__confirm-modal-header">
                  <h3>{{ 'reports.customRow.deleteConfirmTitle' | translate }}</h3>
                  <p>{{ 'reports.customRow.deleteConfirmMessage' | translate:{ name: deleteTarget.description || (getEntryTypeLabel('custom')) } }}</p>
                </div>
                <p class="reports__add-panel-error" *ngIf="deleteError">{{ deleteError }}</p>
                <div class="reports__confirm-modal-actions">
                  <button type="button" class="ghost-btn compact" (click)="cancelDeleteCustomRow()" [disabled]="isDeletingCustomRow">
                    {{ 'common.cancel' | translate }}
                  </button>
                  <button type="button" class="danger-btn" (click)="executeDeleteCustomRow()" [disabled]="isDeletingCustomRow">
                    {{ isDeletingCustomRow ? ('common.saving' | translate) : ('reports.actions.delete' | translate) }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Add custom row form panel -->
          <div class="reports__add-panel surface-card" *ngIf="isCreatingCustomRow">
            <div class="reports__add-panel-header">
              <span class="reports__add-panel-title">{{ (editingEntryId ? 'reports.consumerCustomRow.editTitle' : 'reports.consumerCustomRow.title') | translate }}</span>
              <button type="button" class="reports__add-panel-close" (click)="cancelCustomRow()" [disabled]="isSavingCustomRow">×</button>
            </div>
            <div class="reports__add-panel-fields">
              <div class="reports__form-group">
                <label class="reports__form-label">{{ 'reports.consumerCustomRow.fields.reportDate' | translate }}</label>
                <input class="reports__form-input" type="date" [(ngModel)]="consumerCustomRow.ReportDate">
              </div>
              <div class="reports__form-group">
                <label class="reports__form-label">{{ 'reports.consumerCustomRow.fields.entryAmount' | translate }}</label>
                <input class="reports__form-input" type="number" min="0" step="1" [(ngModel)]="consumerCustomRow.EntryAmount">
              </div>
              <div class="reports__form-group">
                <label class="reports__form-label">{{ 'reports.consumerCustomRow.fields.entryCost' | translate }}</label>
                <input class="reports__form-input" type="number" min="0" step="0.01" [(ngModel)]="consumerCustomRow.EntryCost">
              </div>
              <div class="reports__form-group reports__form-group--wide">
                <label class="reports__form-label">{{ 'reports.consumerCustomRow.fields.entryDescription' | translate }}</label>
                <input class="reports__form-input" type="text" [(ngModel)]="consumerCustomRow.EntryDescription">
              </div>
            </div>
            <p class="reports__add-panel-error" *ngIf="customRowError">{{ customRowError }}</p>
            <div class="reports__add-panel-actions">
              <button type="button" class="primary-btn" (click)="saveCustomRow()" [disabled]="isSavingCustomRow || !consumerCustomRow.ReportDate">
                {{ 'reports.consumerCustomRow.save' | translate }}
              </button>
              <button type="button" class="ghost-btn compact" (click)="cancelCustomRow()" [disabled]="isSavingCustomRow">
                {{ 'common.cancel' | translate }}
              </button>
            </div>
          </div>

        </section>
      </div>
    </section>
  </section>
</main>
